import React, { useEffect, useState } from 'react';
import { Box, Toolbar } from '@mui/material';

import { useQueryString } from 'hooks/useQueryString';
import { CatalogService } from 'api/catalog/services';
import ProductListing from 'ui/ProductListing';
import { IItems } from 'api/catalog/models';
import Refine from 'ui/Refine';
import { DomId } from 'constants/DomId';
import ProductListingOptions from 'ui/ProductListingOptions';
import ServiceError from 'ui/ErrorDisplay/ServiceError';

const PageSearch = () => {
  const { parsedQueryString } = useQueryString();
  const [isLoading, setIsLoading] = useState(true);
  const [results, setResults] = useState<IItems>();
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setIsError(false);
    setIsLoading(true);
    CatalogService.search(parsedQueryString)
      .then((res) => {
        setResults(res.data);
      })
      .catch((isError) => {
        setIsError(true);
        console.warn('isError: ', isError);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [parsedQueryString]);

  return isError ? (
    <ServiceError />
  ) : (
    <Box>
      <Toolbar
        id={DomId.SearchHeaderArea}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Refine facets={results?.facets} />
        <ProductListingOptions />
      </Toolbar>
      <ProductListing
        isLoading={isLoading}
        results={results}
        isFixedHeight
        // paginationContentArea={<Footer />}
      />
    </Box>
  );
};

export default PageSearch;
